export const commonErrorsData = {
  title: "es.error_handling.title",
  errors: [
    {
      error: "es.error_handling.errors.0.error",
      details: {
        iOS: "es.error_handling.errors.0.details.iOS",
        Android: "es.error_handling.errors.0.details.Android",
      },
    },
    {
      error: "es.error_handling.errors.1.error",
      details: "es.error_handling.errors.1.details",
    },
    {
      error: "es.error_handling.errors.2.error",
      details: "es.error_handling.errors.2.details",
    },
    {
      error: "es.error_handling.errors.3.error",
      details: "es.error_handling.errors.3.details",
    },
  ],
}